// Wikifactory Theme colors

const themeColors = {
  // WF colors
  wfWhite: '#ffffff',
  wfBlack: '#000000',

  wfGrey: '#3D3D3D',
  wfGrey900: '#444444',
  wfGrey800: '#646464',
  wfGrey700: '#777777',
  wfGrey600: '#8B8B8B',
  wfGrey500: '#9E9E9E',
  wfGrey400: '#B1B1B1',
  wfGrey300: '#C5C5C5',
  wfGrey200: '#D8D8D8',
  wfGrey100: '#f9f9f9',
  wfGrey50: '#F5F5F5',

  wfYellow: '#ffcb00',
  wfYellow900: '#FED119',
  wfYellow800: '#FFD632',
  wfYellow700: '#FFDB4D',
  wfYellow600: '#FFE066',
  wfYellow500: '#FFE680',
  wfYellow400: '#FFEB99',
  wfYellow300: '#FFEFB2',
  wfYellow200: '#FFF4CC',
  wfYellow100: '#FFFAE6',

  wfBlue: '#0f2eff',
  wfBlue900: '#1950FF',
  wfBlue800: '#3363FF',
  wfBlue700: '#4D76FF',
  wfBlue600: '#658BFF',
  wfBlue500: '#809DFF',
  wfBlue400: '#98B1FF',
  wfBlue300: '#B2C4FF',
  wfBlue200: '#CCD8FF',
  wfBlue100: '#E6ECFF',

  wfGreen: '#00d54c',
  wfGreen900: '#19D46E',
  wfGreen800: '#33D97E',
  wfGreen700: '#4CDE8E',
  wfGreen600: '#67E39E',
  wfGreen500: '#80E7AF',
  wfGreen400: '#98ECBF',
  wfGreen300: '#B2F1CF',
  wfGreen200: '#CCF6DF',
  wfGreen100: '#E6FBEF',

  wfOrange: '#ff4d00',
  wfOrange900: '#FF6E18',
  wfOrange800: '#FF7D34',
  wfOrange700: '#FF8E4C',
  wfOrange600: '#FF9E66',
  wfOrange500: '#FFAE7F',
  wfOrange400: '#FFBE98',
  wfOrange300: '#FFCFB2',
  wfOrange200: '#FFDECC',
  wfOrange100: '#FFEFE6',

  wfPurple: '#9000ff',
  wfPurple900: '#8F40FF',
  wfPurple800: '#9C56FF',
  wfPurple700: '#A86BFF',
  wfPurple600: '#B57FFF',
  wfPurple500: '#C095FF',
  wfPurple400: '#CDAAFF',
  wfPurple300: '#DAC0FF',
  wfPurple200: '#E6D5FF',
  wfPurple100: '#F3EAFF',

  wfPink: '#ff00ff',

  wfRed: '#ff1111',
  wfRed900: '#ff2929',
  wfRed800: '#ff4141',
  wfRed700: '#ff5858',
  wfRed600: '#ff7070',
  wfRed500: '#ff8888',
  wfRed400: '#ffa0a0',
  wfRed300: '#ffb8b8',
  wfRed200: '#ffcfcf',
  wfRed100: '#ffe7e7',

  // Theme colors
  primary: '#0f2eff',
  primaryLight: '#809DFF',
  primaryLightest: '#E6ECFF',
  primaryDark: '#00218E',

  // RGB colors (x, y, z axes colors)
  red: '#ff1111',
  green: '#11bb11',
  blue: '#1111ff',
  yellow: '#ffff00',

  // Pin annotations
  pinNote: '#ff00ff',
  pinNoteDark: '#884dd9',
  pinInstanceNote: '#FFD700',
  pinInstanceNoteDark: '#FF8C00',

  // Markup
  markupDark: '#bfbf00',
  markup: '#ffff00',
} as const;

type ValueOf<T> = T[keyof T];
export type ThemeColor = ValueOf<typeof themeColors>;
export type ThemeColorKey = keyof typeof themeColors;

export default themeColors;
